import * as React from 'react';
import { Box, Grid } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { CloseOutlined } from '@ant-design/icons';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EditTitleMission from './EditTitleMission';
import MissionService from 'services/mission/MissionService';
import { Mission } from 'models/mission/Mission';

const MissionToolbar = ({
    title,
    onClose,
    openDrawer,
    onDrawer,
    dataMission,
    formConfig,
}) => {
    const [openModal, setOpenModal] = React.useState(false);

    const handleOnClose = action => {
        // if (action === ActionCloseReason.Submit) {
        //     execute();
        // }
        setOpenModal(false);
    };

    return (
        <Toolbar>
            <Grid
                container
                alignItems={'center'}
                justifyContent={'space-between'}
                flexDirection={'row'}
            >
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                >
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseOutlined />
                    </IconButton>
                    <Typography variant="h6" component="div">
                        {title}
                    </Typography>
                </Grid>
                {!!dataMission && (
                    <Grid item>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        textDecoration: 'underline',
                                        fontWeight: 'bold',
                                        marginTop: 1,
                                        marginLeft: 1,
                                    }}
                                >
                                    {dataMission?.title}
                                </Typography>
                                <Typography variant="body2" ml={1}>
                                    {dataMission?.description}
                                </Typography>
                            </div>

                            <IconButton
                                color="inherit"
                                aria-label="edit mission title"
                                edge="end"
                                onClick={() => setOpenModal(true)}
                                sx={{ marginLeft: 2 }}
                            >
                                <EditOutlinedIcon />
                            </IconButton>
                        </Box>
                    </Grid>
                )}

                <Grid
                    item
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: 'max-content',
                    }}
                >
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        onClick={() => onDrawer()}
                    >
                        <KeyboardDoubleArrowLeftIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        noWrap
                        sx={{ marginLeft: '12px', flexGrow: 1 }}
                        component="div"
                    >
                        Actions
                    </Typography>
                </Grid>
            </Grid>

            <EditTitleMission
                service={MissionService}
                entity={Mission}
                defaultValue={dataMission}
                open={openModal}
                onClose={handleOnClose}
                title={'Mission'}
                config={formConfig}
                maxWidth={'sm'}
            />
        </Toolbar>
    );
};

export default MissionToolbar;
